import React, { useContext } from 'react';
import { ContainerContext } from '../../../../../context/ContainerContext';
import { ProductContext } from '../../../../../context/ProductContext';
import { Container } from '../../../../../types/container';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { translate } from '../../../../../types/translation/Translator';
import { ContainerUtil } from '../../../../../util/containers.util';
import { Banner, BannerType } from '../../../../components/Banner';

function getTitle(childProducts: number, childContainers: number): string {
  if (!childProducts && !childContainers) return '';

  if (!childProducts) {
    return translate({
      key: TranslationKey.moveContainerWarningTitleOnlyChildContainers,
      formats: { CHILD_CONTAINERS: childContainers.toString() },
    });
  }

  if (!childContainers) {
    return translate({
      key: TranslationKey.moveContainerWarningTitleOnlyChildProducts,
      formats: { CHILD_PRODUCTS: childProducts.toString() },
    });
  }

  return translate({
    key: TranslationKey.moveContainerWarningTitleChildContainersAndProducts,
    formats: { CHILD_CONTAINERS: childContainers.toString(), CHILD_PRODUCTS: childProducts.toString() },
  });
}

function getBody(childProducts: number, childContainers: number): string {
  if (!childProducts && !childContainers) return '';
  if (!childProducts) return translate({ key: TranslationKey.moveContainerWarningBodyOnlyChildContainers });
  if (!childContainers) return translate({ key: TranslationKey.moveContainerWarningBodyOnlyChildProducts });
  return translate({ key: TranslationKey.moveContainerWarningBodyChildContainersAndProducts });
}

interface MoveContainerWarningBannerProps {
  container: Container | undefined;
}

export default function MoveContainerWarningBanner({ container }: MoveContainerWarningBannerProps) {
  if (!container) return null;

  const { containers } = useContext(ContainerContext);
  const { products } = useContext(ProductContext);

  const { childProducts, childContainers } = ContainerUtil.getAllContainerChildren(containers, products, container);
  const [totalChildProducts, totalChildContainers] = [childProducts.length, childContainers.length];
  const title = getTitle(totalChildProducts, totalChildContainers);
  if (!title) return null;

  return (
    <Banner type={BannerType.warning} title={title} width='w-full'>
      <p>{getBody(totalChildProducts, totalChildContainers)}</p>
    </Banner>
  );
}
